import { GalleryHorizontal } from "lucide-react";

import { SECTION_TYPES } from "@/lib/constants/sections";

const photoCarouselSection = {
  type: SECTION_TYPES.PHOTO_CAROUSEL,
  content: {
    header: "",
    images: [
      {
        imageUrl:
          "https://images.unsplash.com/photo-1592595896551-12b371d546d5?q=60&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3",
        altText: "Brick home with green grass and a blue cloudy sky",
      },
      {
        imageUrl:
          "https://images.unsplash.com/photo-1434082033009-b81d41d32e1c?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        altText: "Small home with a windy driveway and green grass",
      },
      {
        imageUrl:
          "https://images.unsplash.com/photo-1472224371017-08207f84aaae?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        altText: "Home with trees and an orange sunset",
      },
    ],
  },
  meta: {
    displayName: "Photo Carousel",
    displayDescription: "Showcase your best photos in a carousel.",
    displayIcon: GalleryHorizontal,
    variantsCount: 3,
  },
};

export default photoCarouselSection;
